export default __webpack_public_path__ + "1e5662d81aad1d0416df8bd9a2c6e899.png";